export default __webpack_public_path__ + "static/media/home-icon.032d2f5f.webp";